import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=62cf1f98&scoped=true&"
var script = {}
import style0 from "./Business.vue?vue&type=style&index=0&id=62cf1f98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cf1f98",
  null
  
)

export default component.exports